// extracted by mini-css-extract-plugin
export default {"card":"EvaluationRequestCard_card__T2Y44","data":"EvaluationRequestCard_data__zapsX"};